export default {
  kommunicateApi: {
    SEARCH: "/kb/search",
    SEARCH_ELASTIC: "/kb/_search",
    APP_SETTINGS_DOMAIN: "/settings/application",
    PLUGIN_URL_V2: "/v2/kommunicate.app",
  }
};
